/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AssignedLicensesResponse,
  BulkTeamReassignmentRequestByFilterV3,
  BulkUpdateUserIsSuperAdminRequestV2,
  BulkUpdateUserLicensesRequestByFilterV2,
  BulkUpdateUserRolesRequestByFilterV2,
  BulkWorkspaceReassignmentRequestByFilterV2,
  CheckLicenseUpdateResponse,
  CheckLicensesResponse,
  CreateWorkspaceRequest,
  License,
  LicenseUsageResponse,
  MapString,
  PaginatedResultUMTUser,
  PaginatedResultUserAggregate,
  PaginatedResultUserChange,
  PersonalWorkspace,
  RecentWorkspaces,
  SelectWorkspaceRequest,
  UpdateExtensionDownloadStatusRequest,
  UpdateOnboardingStatusRequest,
  UpdateWorkspaceRequest,
  UserIntegrationsResponse,
  UserQueryFilterV2,
  UserUpdatesResponse,
  Workspace,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "workspace";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description find user assigned licenses v3
   *
   * @tags Admin User Table, User Management Table, User Authenticated, User, License, User Management Table
   * @name FindUserAssignedLicensesV3
   * @request GET:/v3/tenant/{tenantId}/users/licenses-assigned/types
   * @secure
   */
  findUserAssignedLicensesV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      AssignedLicensesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses-assigned/types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserAssignedLicensesV3 */
  findUserAssignedLicensesV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses-assigned/types`);

  /**
   * No description
   *
   * @tags Admin User Table, User Management Table, User Authenticated, User, License, User Management Table
   * @name FindUserAssignedLicensesUsageV3
   * @request GET:/v3/tenant/{tenantId}/users/licenses-assigned/count
   * @secure
   */
  findUserAssignedLicensesUsageV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      LicenseUsageResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses-assigned/count`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserAssignedLicensesUsageV3 */
  findUserAssignedLicensesUsageV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses-assigned/count`);

  /**
   * @description internal check user licenses v3
   *
   * @tags Internal
   * @name InternalCheckUserLicensesV3
   * @request GET:/v3/tenant/{tenantId}/users/check-licenses
   */
  internalCheckUserLicensesV3 = (
    tenantId: string,
    query?: {
      license?: License[];
      userId?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CheckLicensesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/check-licenses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for internalCheckUserLicensesV3 */
  internalCheckUserLicensesV3PathGetter = (
    tenantId: string,
    query?: {
      license?: License[];
      userId?: string[];
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/users/check-licenses`, query);

  /**
   * @description get user recent workspaces v3
   *
   * @tags User Authenticated, User, Recent Workspaces, Admin User Table, User Management Table, UMT
   * @name GetUserRecentWorkspacesV3
   * @request GET:/v3/tenant/{tenantId}/user/{userId}/workspaces/recent
   * @secure
   */
  getUserRecentWorkspacesV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      RecentWorkspaces,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserRecentWorkspacesV3 */
  getUserRecentWorkspacesV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`);

  /**
   * @description store user selected recent workspace v3
   *
   * @tags User Authenticated, User, Recent Workspaces, Admin User Table, User Management Table, UMT
   * @name StoreUserSelectedRecentWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/user/{userId}/workspaces/recent
   * @secure
   */
  storeUserSelectedRecentWorkspaceV3 = (
    tenantId: string,
    userId: string,
    data: SelectWorkspaceRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      RecentWorkspaces,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for storeUserSelectedRecentWorkspaceV3 */
  storeUserSelectedRecentWorkspaceV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`);

  /**
   * @description export users as csv v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name ExportUsersAsCsvV3
   * @request POST:/v3/tenant/{tenantId}/users/csv
   * @secure
   */
  exportUsersAsCsvV3 = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/csv`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportUsersAsCsvV3 */
  exportUsersAsCsvV3PathGetter = (
    tenantId: string,
    query?: {
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/users/csv`, query);

  /**
   * @description Gets changelog of a user v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name GetUserChangelogV3
   * @request GET:/v3/tenant/{tenantId}/user-changelog
   * @secure
   */
  getUserChangelogV3 = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      userId?: string;
      callerRef?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserChange,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user-changelog`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserChangelogV3 */
  getUserChangelogV3PathGetter = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      userId?: string;
      callerRef?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/user-changelog`, query);

  /**
   * @description get used integrations v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name GetUsedIntegrationsV3
   * @request GET:/v3/tenant/{tenantId}/used-integrations
   * @secure
   */
  getUsedIntegrationsV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      UserIntegrationsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/used-integrations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsedIntegrationsV3 */
  getUsedIntegrationsV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/used-integrations`);

  /**
   * @description find users by filter v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name FindUsersByFilterV3
   * @request POST:/v3/tenant/{tenantId}/users
   * @secure
   */
  findUsersByFilterV3 = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserAggregate,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUsersByFilterV3 */
  findUsersByFilterV3PathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/users`, query);

  /**
   * @description update user onboarding status v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name UpdateUserOnboardingStatusV3
   * @request POST:/v3/tenant/{tenantId}/user/{userId}/onboarding-status
   * @secure
   */
  updateUserOnboardingStatusV3 = (
    tenantId: string,
    userId: string,
    data: UpdateOnboardingStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/onboarding-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserOnboardingStatusV3 */
  updateUserOnboardingStatusV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/onboarding-status`);

  /**
   * @description update user extension download status v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name UpdateUserExtensionDownloadStatusV3
   * @request POST:/v3/tenant/{tenantId}/user/{userId}/extension-download-status
   * @secure
   */
  updateUserExtensionDownloadStatusV3 = (
    tenantId: string,
    userId: string,
    data: UpdateExtensionDownloadStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/extension-download-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserExtensionDownloadStatusV3 */
  updateUserExtensionDownloadStatusV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/extension-download-status`);

  /**
   * @description remove users by filter v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name RemoveUsersByFilterV3
   * @request DELETE:/v3/tenant/{tenantId}/users/by-filter
   * @secure
   */
  removeUsersByFilterV3 = (tenantId: string, data: UserQueryFilterV2, params: RequestParams = {}) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/by-filter`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersByFilterV3 */
  removeUsersByFilterV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/users/by-filter`);

  /**
   * @description bulk update users by id is admin v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name BulkUpdateUsersByIdIsAdminV3
   * @request POST:/v3/tenant/{tenantId}/users/super-admin
   * @secure
   */
  bulkUpdateUsersByIdIsAdminV3 = (
    tenantId: string,
    data: BulkUpdateUserIsSuperAdminRequestV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/super-admin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersByIdIsAdminV3 */
  bulkUpdateUsersByIdIsAdminV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/super-admin`);

  /**
   * @description bulk update users by filter roles v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name BulkUpdateUsersByFilterRolesV3
   * @request POST:/v3/tenant/{tenantId}/users/roles/by-filter
   * @secure
   */
  bulkUpdateUsersByFilterRolesV3 = (
    tenantId: string,
    data: BulkUpdateUserRolesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/roles/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersByFilterRolesV3 */
  bulkUpdateUsersByFilterRolesV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/roles/by-filter`);

  /**
   * @description bulk update users by filter licenses v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name BulkUpdateUsersByFilterLicensesV3
   * @request POST:/v3/tenant/{tenantId}/users/licenses/by-filter
   * @secure
   */
  bulkUpdateUsersByFilterLicensesV3 = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersByFilterLicensesV3 */
  bulkUpdateUsersByFilterLicensesV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses/by-filter`);

  /**
   * @description bulk update users assigned workspaces workspace v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name BulkUpdateUsersAssignedWorkspacesWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/users/workspaces/by-filter
   * @secure
   */
  bulkUpdateUsersAssignedWorkspacesWorkspaceV3 = (
    tenantId: string,
    data: BulkWorkspaceReassignmentRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/workspaces/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersAssignedWorkspacesWorkspaceV3 */
  bulkUpdateUsersAssignedWorkspacesWorkspaceV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/workspaces/by-filter`);

  /**
   * @description bulk update users assigned teams v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name BulkUpdateUsersAssignedTeamsV3
   * @request POST:/v3/tenant/{tenantId}/users/teams/by-filter
   * @secure
   */
  bulkUpdateUsersAssignedTeamsV3 = (
    tenantId: string,
    data: BulkTeamReassignmentRequestByFilterV3,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/teams/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersAssignedTeamsV3 */
  bulkUpdateUsersAssignedTeamsV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/teams/by-filter`);

  /**
   * @description check if bulk update users by filter licenses v3 is possible
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated
   * @name CheckIfBulkUpdateUsersByFilterLicensesV3IsPossible
   * @request POST:/v3/tenant/{tenantId}/users/licenses/by-filter/check
   * @secure
   */
  checkIfBulkUpdateUsersByFilterLicensesV3IsPossible = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      CheckLicenseUpdateResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses/by-filter/check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkIfBulkUpdateUsersByFilterLicensesV3IsPossible */
  checkIfBulkUpdateUsersByFilterLicensesV3IsPossiblePathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses/by-filter/check`);

  /**
   * @description Query UMT users by filters
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindUserManagementTableUsersV3
   * @request POST:/v3/tenant/{tenantId}/user-management-table/users/by-filter
   * @secure
   */
  findUserManagementTableUsersV3 = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUMTUser,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user-management-table/users/by-filter`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserManagementTableUsersV3 */
  findUserManagementTableUsersV3PathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/user-management-table/users/by-filter`, query);

  /**
   * @description create workspace v3
   *
   * @tags Workspaces, User Authenticated
   * @name CreateWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/workspace
   * @secure
   */
  createWorkspaceV3 = (tenantId: string, data: CreateWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createWorkspaceV3 */
  createWorkspaceV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/workspace`);

  /**
   * @description find workspace by id
   *
   * @tags Workspaces, User Authenticated
   * @name GetWorkspaceV3
   * @request GET:/v3/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  getWorkspaceV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspaceV3 */
  getWorkspaceV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description update workspace by id
   *
   * @tags Workspaces, User Authenticated
   * @name UpdateWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  updateWorkspaceV3 = (
    tenantId: string,
    workspaceId: string,
    data: UpdateWorkspaceRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspaceV3 */
  updateWorkspaceV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description find personal workspace by user id
   *
   * @tags Workspaces, User Authenticated
   * @name GetWorkspacePersonalV3
   * @request GET:/v3/tenant/{tenantId}/workspace/personal/user/{userId}
   * @secure
   */
  getWorkspacePersonalV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/personal/user/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspacePersonalV3 */
  getWorkspacePersonalV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/personal/user/${userId}`);

  /**
   * @description soft delete workspace by id
   *
   * @tags Workspaces, User Authenticated
   * @name SoftDeleteWorkspaceV3
   * @request DELETE:/v3/tenant/{tenantId}/workspace/{workspaceId}/soft
   * @secure
   */
  softDeleteWorkspaceV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/soft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for softDeleteWorkspaceV3 */
  softDeleteWorkspaceV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/soft`);

  /**
   * @description guest get personal workspace by user id v3
   *
   * @tags Workspaces, Guest Authenticated Endpoints
   * @name GuestGetPersonalWorkspaceV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/workspaces/personal
   * @secure
   */
  guestGetPersonalWorkspaceV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/workspaces/personal`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetPersonalWorkspaceV3 */
  guestGetPersonalWorkspaceV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/user/${userId}/workspaces/personal`);
}
